import React from 'react'
import { YearMonthPickerContext } from './year-month-root'
import { OverrideComponentProps } from '../utils/overridable-component-helper'
import { composeEventHandlers } from '../utils/compose-event-handlers'

export type YearMonthPickerPrevProps<Tag extends React.ElementType<any>> = OverrideComponentProps<Tag>

export const YearMonthPickerPrev = React.forwardRef<HTMLDivElement, YearMonthPickerPrevProps<any>>(
  ({ as = 'button', ...props }, ref) => {
    const context = React.useContext(YearMonthPickerContext)
    if (!context) {
      throw new Error('Cannot find year month picker context')
    } else {
      return React.createElement(as, {
        ...props,
        ref: ref,
        onClick: composeEventHandlers(props.onClick, context.goToPreviousYear)
      })
    }
  }
) as WithForwardRefType

YearMonthPickerPrev.displayName = 'YearMonthPickerPrev'

interface WithForwardRefType extends React.FC<YearMonthPickerPrevProps<React.ElementType<any>>> {
  <T extends React.ElementType<any> = 'button'>(
    props: YearMonthPickerPrevProps<T>
  ): ReturnType<React.FC<YearMonthPickerPrevProps<T>>>
}
